import { Component, Input, OnInit } from '@angular/core';
import { Sensor } from '../sensor';

@Component({
    selector: 'sensor-v1',
    templateUrl: 'sensor-v1.component.html',
    styleUrls: ['./sensor-v1.component.scss']
})
export class SensorV1Component implements OnInit {
    @Input() sensor: Sensor;
    constructor() { }

    ngOnInit() { }
}